module.exports = __webpack_public_path__ + "img/agent1.5d8469e6.png";